import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';

import MmenuLight from 'mmenu-light';
import './MobilePopMenu.scss';
import { NavLink } from 'react-router-dom';
import HeaderBar from '../HeaderBar';

import c from '../../config';

import { isExternalURL, parseSanitizedHTML } from '../../utils/Helper';

const MobilePopMenu = ({ isOpen, setIsOpen, menu, enableTSSSO, ...props }) => {
  const [drawer, setdrawer] = useState(null);

  const [isSubMenu, setIsSubMenu] = useState(null);

  const initMenu = () => {
    const menuEle = new MmenuLight(document.querySelector('#menu'));

    // menuEle.navigation({
    //   title: '',
    // });

    const drawerEle = menuEle.offcanvas({
      position: 'right',
    });

    setdrawer(drawerEle);
  };

  useEffect(() => {
    initMenu();
  }, []);

  useEffect(() => {
    if (drawer) {
      if (isOpen) {
        drawer.open();
      } else {
        drawer.close();
      }
    }
  }, [isOpen]);

  const generateMenu = (items = []) => {
    const menuItems = [];
    if (items.length > 0) {
      items.map((item, i) => {
        if (item.menu_level_2) {
          menuItems.push(
            <li key={i} title={parseSanitizedHTML(item.title)}>
              <span onClick={() => setIsSubMenu(item.title)}>{item.title}</span>
              <ul className={`${isSubMenu === item.title && 'mm-spn--open'}`}>
                {item.url && linkEle(item)}
                {generateDropDownMenu(item, i)}
              </ul>
            </li>,
          );
        } else {
          menuItems.push(linkEle(item, `generateMenu${i}`));
        }
        return '';
      });
    }
    return menuItems;
  };

  // Level 2
  const generateDropDownMenu = (item, i) => {
    const result = [];
    let url = '';

    if (item.url) {
      url = linkEle(item, i);
    } else {
      url = (
        <span className="nav-link active" target="_blank" rel="noopener noreferrer">
          {parseSanitizedHTML(item.title)}
        </span>
      );
    }
    result.push(generateMenuItems(item.menu_level_2, i));
    return result;
  };

  const linkEle = (item, i) => {
    if (isExternalURL(item.url)) {
      return (
        <li key={i}>
          <a href={item.url} className="nav-link" target="_blank" rel="noopener noreferrer">
            {parseSanitizedHTML(item.title)}
          </a>
        </li>
      );
    }
    return (
      <li key={i}>
        <NavLink
          to={(location) => ({ ...location, pathname: c.routePathTo + item.url })}
          className="nav-link"
          activeClassName="active"
          onClick={() => {
            setIsOpen(false);
            setIsSubMenu(false);
          }}
        >
          {parseSanitizedHTML(item.title)}
        </NavLink>
      </li>
    );
  };

  const generateMenuItems = (items = [], i) => {
    const url = [];
    let newItems = [];
    if (typeof items !== 'undefined' && items instanceof Array) {
      newItems = items;
    } else {
      newItems.push(items);
    }
    if (newItems.length > 0) {
      newItems.map((item, k) => {
        url.push(linkEle(item, `generateMenuItems${i}-${k}`));
        return '';
      });
    }
    return url;
  };

  let menuDropdown;

  if (!isEmpty(menu)) {
    menuDropdown = generateMenu(menu.menu_level_1);
  }

  return (
    <div>
      <nav
        id="menu"
        className={`mm-spn mm-spn--light mm-spn--navbar ${!isSubMenu ? 'mm-spn--main' : ''} ${
          !isOpen ? 'mm-spn--vertical' : ''
        }`}
      >
        <div className="mmenu-overlay" />

        <div className={`prevBtn ${!isSubMenu ? 'd-none' : ''}`}>
          <button
            onClick={() => {
              setIsSubMenu(false);
            }}
            type="button"
            title="Close Menu"
            className="mmenu__prev"
          >
            <span className="visually-hidden">Close</span>
          </button>
        </div>
        <div className="closeBtn">
          <button
            onClick={() => {
              setIsOpen(false);
              setIsSubMenu(false);
            }}
            type="button"
            title="Close Menu"
            className="mmenu__close"
          >
            <span className="visually-hidden">Close</span>
          </button>
        </div>
        <ul className={`${isOpen ? 'mm-spn--open' : ''}  ${isSubMenu ? 'mm-spn--parent' : ''}`}>
          {menuDropdown}
        </ul>
        <div className="mobile-menu-bottom">
          <HeaderBar type="MainMenu" enableTSSSO={enableTSSSO} />
        </div>
      </nav>
    </div>
  );
};

export default MobilePopMenu;
